const LOCAL_STORAGE_KEYS = {
  tokens: 'tokens',
  redirectUrl: 'redirectUrl',
  goBackUrl: 'goBackUrl',
  depersonateGoBackUrl: 'depersonateGoBackUrl'
};

export default LOCAL_STORAGE_KEYS;
